import {CSSProperties} from "react";

export const disableOnTrue = (flag: boolean | undefined): CSSProperties => {
    return {
        pointerEvents: flag ? 'none' : 'initial',
        opacity: flag ? 0.15 : 1,
    }
}

